<template>
    <div>
        <div class="row my-3">
            <h1 class="col-sm-12">Reclamaciones</h1>
        </div>

        <DataGrid :configuracion="datagrid_config" :data="reclamaciones" @ready="buscar_btns">
            <button class="btn btn-secondary mr-2" @click="obtener_reclamaciones"><i class="fa-solid fa-rotate"></i>
                Actualizar</button>
            <button class="btn btn-primary" @click="show_modal = true"><i class="fa-solid fa-plus"></i> Crear</button>
        </DataGrid>

        <formulario-reclamacion v-if="show_modal" :prop_reclamacion="reclamacion" @close="cerrar_modal" @update="cerrar_modal(true)" />

    </div>
</template>

<script>
import DataGrid from '@/components/DataGridV3.vue';
import apiCondusefReclamaciones from '@/apps/condusef/api/reclamaciones';
import FormularioReclamacion from "@/apps/condusef/pages/Reclamaciones/FormularioReclamacion.vue";

export default {
    components: { DataGrid, FormularioReclamacion },
    data() {
        return {
            datagrid_config: {
                cols: {
                    folio_condusef: 'Folio Condusef',
                    folio_atencion: 'Folio Atención',
                    trimestre_label: 'Trimestre',
                    estatus_reclamacion: 'Estatus',
                    created_at: 'Fecha Creación',
                    otros: '',
                },
                mutators: {
                  folio_atencion(val, row, vue) {

                    return val && val.length && val.length > 15 ? val.substr(0, 15) + '...' : val;
                  },
                  estatus_reclamacion(val, row, vue) {
                    return "<span class='" + (val == 1 ? 'badge badge-warning' : 'badge badge-success') + "'>" + (val == 1 ? 'Pendiente' : 'Concluido') + "</span>";
                  },
                  created_at(val, row, vue) {
                    return vue.$moment(val).format('YYYY-MM-DD HH:SS:DD');
                  },
                  otros(val, row, vue) {
                    return '<button class="btn btn-secondary btn-accion" data-reclamacion="' + vue.$helper.toJson(row) + '"><i class="fa-regular fa-eye"></i></button>'
                  }
                },
                selector: false,
            },
            reclamaciones: [],
            reclamacion: {
              folio_atencion: null
            },
            show_modal: false,
        }
    },
    mounted() {
        this.obtener_reclamaciones();
    },
    methods: {
        async obtener_reclamaciones() {
            try {
                this.reclamaciones = (await apiCondusefReclamaciones.listar()).data;
            } catch (error) {
                this.$log.error('error', error);
                this.$helper.showAxiosError(error, 'Error');
            }
        },
        buscar_btns() {
            document.querySelectorAll('button.btn-accion').forEach(btn => {
                btn.removeEventListener('click', this.abrir_modal);
                btn.addEventListener('click', this.abrir_modal);
            })
        },
        abrir_modal(event) {
            let btn = event.target;

            if (btn.tagName == 'I')
                btn = btn.parentElement;

            this.reclamacion = this.$helper.fromJson(btn.dataset.reclamacion);

            this.show_modal = true;
        },
        cerrar_modal(recargar) {
            if (typeof recargar == ' undefined')
                recargar = false

            this.show_modal = false;
            this.reclamacion = { folio_atencion: null }

            if (recargar)
                this.obtener_reclamaciones();

        }

    },

}
</script>